<!--
  One inline sprite for the whole app: zero network requests, fixed 9x9/11x11
  metrics and no platform emoji font. Keep every shape on integer coordinates.
-->
<svg class="pixel-sprite" aria-hidden="true" focusable="false">
  <defs>
    <symbol id="av-cyan" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a0820" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#00e5ff"
      /><rect x="1" y="2" width="7" height="4" fill="#00b8d4" />
      <rect x="2" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="5"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="2" y="3" width="1" height="1" fill="#eafcff" /><rect
        x="5"
        y="3"
        width="1"
        height="1"
        fill="#eafcff"
      />
      <rect x="3" y="5" width="3" height="1" fill="#0b0a16" /><rect
        x="1"
        y="6"
        width="7"
        height="2"
        fill="#0e7b8c"
      /><rect x="3" y="6" width="3" height="1" fill="#ffe14d" /><rect
        x="0"
        y="2"
        width="1"
        height="3"
        fill="#00e5ff"
      /><rect x="8" y="2" width="1" height="3" fill="#00e5ff" />
    </symbol>
    <symbol id="av-cyan-on" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a1e26" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#eafcff"
      /><rect x="1" y="2" width="7" height="4" fill="#00d6f0" />
      <rect x="2" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="5"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="2" y="3" width="1" height="1" fill="#fff" /><rect
        x="5"
        y="3"
        width="1"
        height="1"
        fill="#fff"
      />
      <rect x="3" y="5" width="3" height="1" fill="#0b0a16" /><rect
        x="1"
        y="6"
        width="7"
        height="2"
        fill="#0e7b8c"
      /><rect x="3" y="6" width="3" height="1" fill="#ffe14d" /><rect
        x="0"
        y="2"
        width="1"
        height="3"
        fill="#eafcff"
      /><rect x="8" y="2" width="1" height="3" fill="#eafcff" />
    </symbol>
    <symbol id="av-mag" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a0820" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#ff3ea5"
      /><rect x="1" y="2" width="7" height="4" fill="#d61b7f" />
      <rect x="2" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="5"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="3" y="3" width="1" height="1" fill="#ffe6f4" /><rect
        x="6"
        y="3"
        width="1"
        height="1"
        fill="#ffe6f4"
      />
      <rect x="3" y="5" width="3" height="1" fill="#0b0a16" /><rect
        x="1"
        y="6"
        width="7"
        height="2"
        fill="#8c1f5c"
      /><rect x="3" y="6" width="3" height="1" fill="#00e5ff" /><rect
        x="0"
        y="2"
        width="1"
        height="3"
        fill="#ff3ea5"
      /><rect x="8" y="2" width="1" height="3" fill="#ff3ea5" />
    </symbol>
    <symbol id="av-mag-on" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#2a0a1a" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#ffe6f4"
      /><rect x="1" y="2" width="7" height="4" fill="#f02a92" />
      <rect x="2" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="5"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="3" y="3" width="1" height="1" fill="#fff" /><rect
        x="6"
        y="3"
        width="1"
        height="1"
        fill="#fff"
      />
      <rect x="3" y="5" width="3" height="1" fill="#0b0a16" /><rect
        x="1"
        y="6"
        width="7"
        height="2"
        fill="#8c1f5c"
      /><rect x="3" y="6" width="3" height="1" fill="#00e5ff" /><rect
        x="0"
        y="2"
        width="1"
        height="3"
        fill="#ffe6f4"
      /><rect x="8" y="2" width="1" height="3" fill="#ffe6f4" />
    </symbol>
    <symbol id="av-hit" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#3a0f18" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#ff5a3c"
      /><rect x="1" y="2" width="7" height="4" fill="#c4185f" />
      <rect x="2" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="5"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="2" y="3" width="1" height="1" fill="#fff" /><rect
        x="6"
        y="3"
        width="1"
        height="1"
        fill="#fff"
      /><rect x="3" y="4" width="3" height="1" fill="#ff5a3c" /><rect
        x="3"
        y="5"
        width="3"
        height="1"
        fill="#0b0a16"
      />
      <rect x="1" y="6" width="7" height="2" fill="#7a1a3f" /><rect
        x="3"
        y="6"
        width="3"
        height="1"
        fill="#ffe14d"
      /><rect x="0" y="1" width="1" height="1" fill="#ffe14d" /><rect
        x="8"
        y="5"
        width="1"
        height="1"
        fill="#ffe14d"
      /><rect x="0" y="2" width="1" height="3" fill="#ff5a3c" /><rect
        x="8"
        y="2"
        width="1"
        height="3"
        fill="#ff5a3c"
      />
    </symbol>
    <symbol id="av-empty" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a0820" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#2f2a5c"
      /><rect x="1" y="2" width="7" height="4" fill="#241f4a" /><rect
        x="1"
        y="6"
        width="7"
        height="2"
        fill="#1c1840"
      />
      <rect x="3" y="2" width="3" height="1" fill="#6b64b0" /><rect
        x="5"
        y="3"
        width="1"
        height="1"
        fill="#6b64b0"
      /><rect x="4" y="4" width="1" height="1" fill="#6b64b0" /><rect
        x="4"
        y="6"
        width="1"
        height="1"
        fill="#6b64b0"
      /><rect x="0" y="2" width="1" height="3" fill="#2f2a5c" /><rect
        x="8"
        y="2"
        width="1"
        height="3"
        fill="#2f2a5c"
      />
    </symbol>
    <symbol id="av-grn" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a0820" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#4dff88"
      /><rect x="1" y="2" width="7" height="4" fill="#2bc464" /><rect
        x="2"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="5" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="2"
        y="3"
        width="1"
        height="1"
        fill="#fff"
      /><rect x="5" y="3" width="1" height="1" fill="#fff" /><rect
        x="3"
        y="5"
        width="3"
        height="1"
        fill="#0b0a16"
      /><rect x="1" y="6" width="7" height="2" fill="#0a5c2b" />
    </symbol>
    <symbol id="av-yel" viewBox="0 0 9 9">
      <rect width="9" height="9" fill="#0a0820" /><rect
        x="2"
        y="1"
        width="5"
        height="1"
        fill="#ffe14d"
      /><rect x="1" y="2" width="7" height="4" fill="#d4b619" /><rect
        x="2"
        y="3"
        width="2"
        height="1"
        fill="#0b0a16"
      /><rect x="5" y="3" width="2" height="1" fill="#0b0a16" /><rect
        x="2"
        y="3"
        width="1"
        height="1"
        fill="#fff"
      /><rect x="5" y="3" width="1" height="1" fill="#fff" /><rect
        x="3"
        y="5"
        width="3"
        height="1"
        fill="#0b0a16"
      /><rect x="1" y="6" width="7" height="2" fill="#6b5200" />
    </symbol>

    <symbol id="icon-trophy" viewBox="0 0 11 11"
      ><path
        d="M2 1h7v2h2v3H9v2H7v1h2v2H2V9h2V8H2V6H0V3h2V1Zm1 1v4h5V2H3ZM1 4v1h1V4H1Zm8 0v1h1V4H9Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-swords" viewBox="0 0 11 11"
      ><path
        d="M1 0h2v2h1v1h1v2H3V4H2V3H1V0Zm7 0h2v3H9v1H8v1H6V3h1V2h1V0ZM4 6h3v1h1v1h1v2H7V9H4v1H2V8h1V7h1V6Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-bot" viewBox="0 0 11 11"
      ><path
        d="M5 0h1v2h3v1h1v6H9v1H2V9H1V3h1V2h3V0ZM3 4v2h2V4H3Zm3 0v2h2V4H6ZM3 8h5V7H3v1Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-lock" viewBox="0 0 11 11"
      ><path
        d="M3 0h5v1h1v4h1v6H1V5h1V1h1V0Zm1 2v3h3V2H4Zm1 5v2h1V7H5Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-timer" viewBox="0 0 11 11"
      ><path
        d="M3 0h5v2H6v1h2v1h1v1h1v4H9v1H2V9H1V5h1V4h1V3h2V2H3V0Zm2 4v3h3V6H6V4H5Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-crown" viewBox="0 0 11 11"
      ><path d="M0 2h2v2h1V1h2v3h1V1h2v3h1V2h2v7H0V2Zm1 8h9v1H1v-1Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-medal-silver" viewBox="0 0 11 11"
      ><path
        d="M2 0h3v4H4V2H3v2H2V0Zm4 0h3v4H8V2H7v2H6V0ZM3 4h5v1h1v5H8v1H3v-1H2V5h1V4Zm2 2v1H4v2h3V8H5v-1h2V6H5Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-medal-bronze" viewBox="0 0 11 11"
      ><path
        d="M2 0h3v4H4V2H3v2H2V0Zm4 0h3v4H8V2H7v2H6V0ZM3 4h5v1h1v5H8v1H3v-1H2V5h1V4Zm1 2v1h2v1H4v1h3V8H6V7h1V6H4Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-bolt" viewBox="0 0 11 11"
      ><path d="M6 0h3L7 4h3l-6 7 1-5H1l5-6Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-infinity" viewBox="0 0 11 11"
      ><path
        d="M2 3h2l2 2 1-2h2l2 2v2L9 9H7L5 7 4 9H2L0 7V5l2-2Zm0 2L1 6l1 1h1l1-1-1-1H2Zm6 0L7 6l1 1h1l1-1-1-1H8Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-check" viewBox="0 0 11 11"
      ><path
        d="M9 1h2v3h-1v2H9v1H8v1H7v1H6v1H4V9H3V8H2V7H1V5h3v1h1v1h1V6h1V4h1V2h1V1Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-close" viewBox="0 0 11 11"
      ><path
        d="M1 1h2v1h1v2h3V2h1V1h2v2H9v1H8v3h1v1h1v2H8V9H7V8H4v1H3v1H1V8h1V7h1V4H2V3H1V1Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-play" viewBox="0 0 11 11"
      ><path d="M2 1h2v1h2v1h2v1h2v3H8v1H6v1H4v1H2V1Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-back" viewBox="0 0 11 11"
      ><path d="M5 1h3L4 5h7v2H4l4 4H5L0 6l5-5Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-arrows" viewBox="0 0 11 11"
      ><path
        d="M5 0 2 3h2v2H2V3L0 5v1l2 2V6h2v2H2l3 3h1l3-3H7V6h2v2l2-2V5L9 3v2H7V3h2L6 0H5Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-gear" viewBox="0 0 11 11"
      ><path
        d="M4 0h3v1h1v1h2v1H9v2h2v1H9v2h1v1H8v1H7v1H4v-1H3v-1H1V8h1V6H0V5h2V3H1V2h2V1h1V0Zm0 4v3h3V4H4Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="icon-info" viewBox="0 0 11 11"
      ><path d="M4 0h3v3H4V0Zm0 4h3v5h2v2H2V9h2V4Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-warning" viewBox="0 0 11 11"
      ><path d="M5 0h1l5 10v1H0v-1L5 0Zm0 3v4h1V3H5Zm0 5v2h1V8H5Z" fill="currentColor" /></symbol
    >
    <symbol id="icon-delete" viewBox="0 0 11 11"
      ><path
        d="M3 1h8v9H3L0 6V5l3-4Zm2 2v2h1V3H5Zm2 0v2H6v2H5v2h1V7h1v2h1V7H7V5h1V3H7Z"
        fill="currentColor"
      /></symbol
    >
    <symbol id="burst" viewBox="0 0 11 11"
      ><path
        d="M5 0h1v2H5V0Zm0 9h1v2H5V9ZM0 5h2v1H0V5Zm9 0h2v1H9V5ZM2 2h1v1H2V2Zm6 0h1v1H8V2ZM2 8h1v1H2V8Zm6 0h1v1H8V8ZM4 3h3v1h1v3H7v1H4V7H3V4h1V3Z"
        fill="currentColor"
      /></symbol
    >
  </defs>
</svg>
